module.exports = __webpack_public_path__ + "img/56.7a03eabb.png";